var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('span',[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"minbox"},_vm._l((_vm.List),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.change(index)}}},[_c('img',{attrs:{"src":item.picUrl,"alt":""}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e41c734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pcIndex.vue
// module id = null
// module chunks = 